import Swiper, { Pagination, Thumbs } from 'swiper';
import 'swiper/css';

const selectors = {
  carouselWrapper: '[data-product-gallery-image-carousel]',
  slide: '[data-product-gallery-slide]',
  thumbnailWrapper: '[data-product-gallery-thumbnail-carousel]',
};

class ProductGallery extends HTMLElement {
  constructor() {
    super();

    this.carouselWrappers = document.querySelectorAll(
      selectors.carouselWrapper
    );

    this.slides = document.querySelectorAll(selectors.slide);

    // Init the carousel on load.
    this.initCarousels();
  }

  initCarousels() {
    // Unhide the hidden slides before initialising the carousel
    this.slides.forEach(slide => slide.classList.remove('hidden'));

    this.thumbnailCarousel = new Swiper(selectors.thumbnailWrapper, {
      direction: 'vertical',
      slidesPerView: 6,
      slideToClickedSlide: true,
      spaceBetween: 20,
      on: {
        init: () => {
          document
            .querySelector(selectors.thumbnailWrapper)
            .classList.remove('invisible', 'lg:w-10');
        },
      },
    });

    // Don't use a carousel on the main gallery for just one image
    if (this.carouselWrappers[0].dataset.mediaLength === '1') {
      return;
    }

    this.galleryCarousel = new Swiper(selectors.carouselWrapper, {
      modules: [Pagination, Thumbs],
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
        renderBullet: (index, className) => {
          let classes = className;

          const slide = document
            .querySelector(selectors.carouselWrapper)
            .querySelectorAll('.swiper-slide')[index];
          const iframe = slide.querySelector('iframe');

          if (iframe) {
            classes += ' swiper-pagination-bullet--video';
          }

          return `<span class="${classes}"></span>`;
        },
      },
      thumbs: {
        swiper: this.thumbnailCarousel,
      },
      on: {
        slideChange: swiper => {
          const slide =
            swiper.el.querySelectorAll('.swiper-slide')[swiper.previousIndex];
          const iframe = slide.querySelector('iframe');

          // No need for the API controller, here. Just reset the iframe's src
          // when changing to a different slide from a video.
          if (iframe) {
            iframe.setAttribute('src', iframe.getAttribute('src'));
          }
        },
      },
      breakpoints: {
        1024: {
          direction: 'vertical',
          pagination: false,
        },
      },
    });
  }
}

customElements.define('product-gallery', ProductGallery);
